import styled from 'styled-components'
import {
  background,
  hFlex,
  square,
  vFlex,
} from '../../../../../../../../../../Styles/style-helpers'
import { H5 } from '../../../../../../../../../../Styles/typography'
import { accent } from '../../../../../../../../../../Styles/colors'
import discussionIllustration from '../../../../../../../../../../Assets/Icons/Recorded/discussion.svg'
import reviewIllustration from '../../../../../../../../../../Assets/Icons/Recorded/reviews.svg'
import { motion } from 'framer-motion'
import arrow from '../../../../../../../../../../Assets/Icons/Student_s Dashboard/Side Menu/arrow.svg'

export const BackgroundEl = styled.div`
  width: calc(100% - 1em);
  background: linear-gradient(to bottom, white 95%, transparent);
  height: 16.5em;
  position: sticky;
  top: 0;
  z-index: 9;
`

export const ActiveEl = styled(motion.div)`
  position: relative;
  width: calc(100% - 7em);
  min-height: calc(100% - 14em);
  margin: 0 2em 0 5em;
`
export const ArtistEl = styled(motion.div)`
  .content {
    background:#e0e0e0 !important;
  }
`

export const TabHeadersEl = styled(motion.div)`
  ${hFlex};
  justify-content: flex-start;
  width: calc(100% - 7em);
  border-bottom: 1px solid black;
  margin: 0 2em 0 5em;
  position: sticky;
  top: ${({ expanded }) => (expanded ? '0' : '12em')};
  background: white;
  z-index: 10;
`

export const TabEl = styled.div`
  margin: 0 2em;
  padding: 0 0.25em 0.75em;
  cursor: pointer;
  border-bottom: ${({ active }) => (active ? `3px solid black` : `none`)};
  user-select: none;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: ${({ active }) => (active ? 1 : 0.5)};
  transform: translate(0, 1.5px);

  &:first-of-type {
    margin-left: 0;
  }
`

export const AboutEl = styled.div`
  padding: 2em 0;
  position: relative;
  width: 100%;
  height: 100%;
  ${hFlex};
  align-items: flex-start;

  .ql-editor {
    padding: 0;

    & p {
      margin-bottom: 1em;
      line-height: 1.5;
      font-size: 1.125em;
    }
  }

  .description {
    flex: 1;

    .ql-editor {
      padding: 0;

      & p {
        margin-bottom: 1em;
        line-height: 1.5;
        font-size: 1.125em;
      }
    }

    .faq {
      background: white;
      padding: 5em 0;
      width: 100%;
      ${vFlex};
      align-items: flex-start;
      margin: 0;

      h3 {
        margin-bottom: 1.5em;
        font-size: 1.5em;
        font-weight: bold;
      }

      ul {
        width: 100%;

        & > li {
          width: 100%;
          box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.15);
          padding: 1em 0.5em;
          margin-bottom: 1.5em;
          cursor: pointer;
          border-radius: 0.5em;

          & > div {
            width: 100%;
            padding: 0;
            margin: 0;
          }
        }
      }

      h6 {
        width: 100%;
        border-radius: 1em;
        ${hFlex};
        justify-content: flex-start;

        .index {
          width: 2.5em;
          padding-left: 1em;
          position: relative;
        }

        .text {
          display: block;
          flex: 1;
        }

        .arrow {
          ${square('1.5em')};
          background: black;
          margin: 0 1em;
          ${background(arrow, 'contain')};
          transform: rotateZ(90deg);
          filter: brightness(0);
          transition: transform 150ms ease;

          &.expanded {
            transform: rotateZ(90deg) rotateY(180deg);
          }
        }
      }

      .answer {
        padding: 2em 3em 0;
        line-height: 1.5;
        opacity: 0.85;

        ol {
          padding-left: 1.5em;

          li {
            margin-bottom: 1em;
          }
        }
      }
    }
  }

  .right {
    width: 25em;
    padding: 1em 2em;
    margin-left: 2em;
    border: 1px solid #ddd;
    border-radius: 1em;

    ${H5} {
      letter-spacing: 0.05em;
      margin: 1em 0;
      width: 100%;
      text-align: center;
    }

    .separator {
      display: block;
      width: 5em;
      height: 1px;
      background: ${accent};
      margin: 1.5em auto;
    }

    .ql-editor ul,
    .ql-editor ol {
      padding-left: 0;
    }
  }
`

export const DiscussionEl = styled.div`
  padding: 2em 0;
  ${vFlex};
  align-items: flex-start;

  .illustration {
    width: 50%;
    height: 25em;
    margin: 0 auto 5em;
    ${background(discussionIllustration, 'contain')}
  }

  ${H5} {
    max-width: 75%;
    text-align: center;
    line-height: 1.5;
    margin: 0 auto;
  }
`

export const ReviewEl = styled.div`
  padding: 2em 0;
  ${vFlex};

  .illustration {
    width: 50%;
    height: 20em;
    margin: 5em 0;
    ${background(reviewIllustration, 'contain')}
  }

  ${H5} {
    max-width: 75%;
    text-align: center;
    line-height: 1.5;
  }
`
